import { AnswerDialog } from './../mc-paper/mc-paper.component';
import { QuestionService } from './../question.service';
import { Component, OnInit ,Inject} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { papers , topics} from '../static'
import {MatDialog , MAT_DIALOG_DATA} from '@angular/material/dialog';


import * as CanvasJS from '../../assets/canvasjs.min.js';
@Component({
  selector: 'app-mc-paper-ans',
  templateUrl: './mc-paper-ans.component.html',
  styleUrls: ['./mc-paper-ans.component.css']
})
export class McPaperAnsComponent implements OnInit {

  papers = papers;
  topics = topics;
  paper;
  questions;
  order;
  title;
  sort;
  type;
  lang = 'E';
  exam;
  paperID;
  constructor(
    private route: ActivatedRoute,
    private QuestionService: QuestionService,
    public dialog: MatDialog
  ) { }

  ngOnInit() {
    this.route.paramMap.subscribe(params => {
      this.order = params.get('order');
      this.exam = params.get('exam');
      this.type = params.get('type');
      this.sort = 'year';
      if (this.type == 'year'){
        this.title = this.papers.find(x => x.id == params.get('paperId')).name;
        
      } else if(this.type == 'topic'){
        this.title = this.topics.find(x => x.tag == params.get('paperId')).name;
        
      }
      this.paperID = params.get('paperId');
      this.questions = this.QuestionService.getQuestion(this.paperID,'year',this.type,this.exam);
    });
}

getQuestion(sort){
  this.sort = sort;    
  this.questions = this.QuestionService.getQuestion(this.paperID,sort,this.type,this.exam);
   
}
setLang(lang){
  this.lang = lang;    
}


openAnswerDialog(question,lang) {
  console.log(question);
  console.log(lang);
  this.dialog.open(AnswerDialog,{
    data: { question: question , lang:lang },
  });
   
 }

}
